<template>
  <v-container fluid>
    <v-row row v-if="model">
      <v-col cols="8">
        <v-row>
          <v-col>
            <v-card>
              <v-toolbar flat>
                <v-toolbar-title>
                  Customer
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn outlined class="mr-2" @click.stop="editItem()">
                  <v-icon left>mdi-pencil</v-icon>Edit
                </v-btn>
                <download-invoice :clientId="model.id" />
              </v-toolbar>
              <v-container fluid>
                <v-row>
                  <v-col cols="4">
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle class="caption">Company:</v-list-item-subtitle>
                          <v-list-item-title>{{ this.model.company }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle class="caption">Lastname:</v-list-item-subtitle>
                          <v-list-item-title>{{ this.model.lastname }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle class="caption">Firstname:</v-list-item-subtitle>
                          <v-list-item-title>{{ this.model.firstname }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                  <v-col cols="4">
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle class="caption">Email:</v-list-item-subtitle>
                          <v-list-item-title>{{ this.model.email }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle class="caption">Mobile:</v-list-item-subtitle>
                          <v-list-item-title>{{ this.model.mobile }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle class="caption">Other Phone:</v-list-item-subtitle>
                          <v-list-item-title>{{ this.model.phone }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                  <v-col cols="4">
                    <v-list dense>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle class="caption">TVA:</v-list-item-subtitle>
                          <v-list-item-title>{{ this.model.tva }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle class="caption">Comments:</v-list-item-subtitle>
                          <v-list-item-title>{{ this.model.comment }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-subtitle class="caption">Accept Communication:</v-list-item-subtitle>
                          <v-list-item-title>{{ this.model.newsletter ? 'Yes' : 'No' }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="mailchimp.length">
          <v-col>
            <v-card>
              <v-toolbar flat>
                <v-toolbar-title>
                  Newsletter
                </v-toolbar-title>
              </v-toolbar>
              <v-simple-table>
                <thead>
                  <tr>
                    <th>List</th>
                    <th>Status</th>
                    <th>Avg Open Rate</th>
                    <th>Avg Click Rate</th>
                    <th>Language</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="list in mailchimp" :key="list.name">
                    <td>{{ list.name }}</td>
                    <td>{{ list.status }}</td>
                    <td>{{ list.stats.avg_open_rate }}</td>
                    <td>{{ list.stats.avg_click_rate }}</td>
                    <td>{{ list.Language }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="4">
        <xperience-detail :client-id="clientId" />
      </v-col>
    </v-row>
    <v-row v-if="model">
      <v-col cols="12">
        <v-card>
          <v-tabs v-model="tabs" color="accent" slider-color="accent">
            <v-tab key="1" ripple>Orders</v-tab>
            <v-tab key="2" ripple>Prescriptions</v-tab>
            <v-tab key="3" ripple>Addresses</v-tab>
            <v-tabs-items v-model="tabs" class="white elevation-1">
              <v-tab-item key="1">
                <order-table :clientId="model.id" />
              </v-tab-item>
              <v-tab-item key="2">
                <prescription-list
                  :headers="prescriptionHeaders"
                  :filters="{ clientId: model.id }"
                ></prescription-list>
              </v-tab-item>
              <v-tab-item key="3">
                <customer-addresses
                  :customer="model"
                  v-if="model"
                ></customer-addresses>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
    <customer-form
      :item="customerToEdit"
      :open="formCustomer"
      v-on:cancel="cancelCustomer()"
      v-on:update="updateCustomer()"
      v-if="model"
    ></customer-form>
  </v-container>
</template>

<script>
import PrescriptionList from "@components/prescriptions/PrescriptionList.vue";
import CustomerForm from "@components/client/CustomerForm";
import CustomerAddresses from "@components/client/CustomerAddresses";
import OrderTable from "@components/orders/OrderTable";
import XperienceDetail from "@components/client/XperienceDetail.vue";
import DownloadInvoice from "@components/customer/DownloadInvoice.vue";
import { mapActions } from "vuex";
export default {
  components: {
    CustomerForm,
    CustomerAddresses,
    OrderTable,
    PrescriptionList,
    XperienceDetail,
    DownloadInvoice,
  },
  data() {
    return {
      mailchimp: [],
      tabs: null,
      clientId: null,
      model: null,
      formCustomer: false,
      formB2B: false,
      customerToEdit: null,
      prescriptionHeaders: [
        /*{ text: "Status", value: "statusId", align: "right" },*/
        { text: "Invoice", value: "invoiceNumber", align: "right" },
        { text: "Customer", value: "client.displayName", align: "left" },
        { text: "Shop", value: "shop.name", align: "left" },
        { text: "Location", value: "location.name", align: "left" },
        { text: "Club Fitter", value: "clubFitter.displayName" },
        { text: "Fitting Type", value: "fittingType.name" },
        { text: "Fitting Date", value: "fittingDate", align: "center" },
        { text: "status", value: "statusId", align: "left" },
        { text: "updated", value: "updated_at", align: "left" },
        { text: "action", value: "action", align: "left" },
      ],
    };
  },
  mounted: function() {
    if (this.$route.params.id) {
      this.clientId = parseInt(this.$route.params.id);
      this.getClient(this.clientId);
    } else {
      this.$route.push("/clients");
    }

    this.getMailchimpList(this.clientId).then((data) => this.mailchimp = data)
  },
  methods: {
    ...mapActions('clients', ['getMailchimpList']),
    getClient() {
      this.$store
        .dispatch("clients/view", {
          id: this.clientId,
          // expand: "shop,taxRate,location,currency",
        })
        .then((data) => {
          this.model = data;
        });
    },
    updateCustomer() {
      this.formCustomer = false;
      this.customerToEdit = null;
      this.getClient();
      this.getMailchimpList(this.clientId).then((data) => this.mailchimp = data)
    },
    cancelCustomer() {
      this.formCustomer = false;
      this.customerToEdit = null;
    },
    updateB2B() {
      console.group("Client View", "Update B2B");
      this.formB2B = false;
      this.customerToEdit = null;
      this.getClient();
    },
    cancelB2B() {
      this.formB2B = false;
      this.customerToEdit = null;
    },
    editItem() {
      this.customerToEdit = Object.assign({}, this.model);
      this.formCustomer = true;
    }
  },
};
</script>
